

export const OrderComment = () => {
    
    return (
        <div className="mb-3">
            <label  className="form-label fs-6 fw-bold">Коментар</label>
            <div className="input-group">
                <textarea className="form-control  " name="comment" placeholder="Додайте свої побажання"></textarea>
            </div>
        </div>
)
}